import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-proactive-support }}\n{{outlet}}",{ moduleName: "embercom/templates/apps/app/outbound/auto.hbs" })